export default __webpack_public_path__ + "static/media/google-play.f2e6ed8c.svg";